export const PERMISSIONS = {
  MANAGE_USERS: 'MANAGE_USERS',
  EDIT_USERS: 'EDIT_USERS',
  DELETE_USERS: 'DELETE_USERS',
  MANAGE_SOULS: 'MANAGE_SOULS',
  MANAGE_SHEPHERDS: 'MANAGE_SHEPHERDS',
  MANAGE_DEPARTMENTS: 'MANAGE_DEPARTMENTS',
  MANAGE_FAMILIES: 'MANAGE_FAMILIES',
  MANAGE_SERVANTS: 'MANAGE_SERVANTS',
  VIEW_STATS: 'VIEW_STATS',
  EXPORT_DATA: 'EXPORT_DATA',
  MANAGE_SETTINGS: 'MANAGE_SETTINGS',
  MANAGE_BACKUP: 'MANAGE_BACKUP',
  MANAGE_PROFILE: 'MANAGE_PROFILE',
  MANAGE_INTERACTIONS: 'MANAGE_INTERACTIONS',
  MANAGE_ATTENDANCES: 'MANAGE_ATTENDANCES',
  MANAGE_SMS: 'MANAGE_SMS',
  MANAGE_AUDIO: 'MANAGE_AUDIO',
  MANAGE_SMS_TEMPLATES: 'MANAGE_SMS_TEMPLATES',
  MANAGE_USER_MENUS: 'MANAGE_USER_MENUS',
  MANAGE_ANNOUNCEMENTS: 'MANAGE_ANNOUNCEMENTS',
  MANAGE_ROLES_PERMISSIONS: 'MANAGE_ROLES_PERMISSIONS',
  PROMOTE_SOUL_TO_SERVANT: 'PROMOTE_SOUL_TO_SERVANT',
  MANAGE_DEPARTMENT_SERVANTS: 'MANAGE_DEPARTMENT_SERVANTS',
  VIEW_REPLAY_TEACHINGS: 'VIEW_REPLAY_TEACHINGS',
  MANAGE_BIRTHDAYS: 'MANAGE_BIRTHDAYS',
  MANAGE_EVANGELIZED_SOULS: 'MANAGE_EVANGELIZED_SOULS',
  ALL: '*'
} as const;

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  SHEPHERD: 'shepherd',
  ADN: 'adn',
  DEPARTMENT_LEADER: 'department_leader',
  FAMILY_LEADER: 'family_leader',
  EVANGELIST: 'evangelist',
} as const;

export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: [PERMISSIONS.ALL],
  [ROLES.ADMIN]: [
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.EDIT_USERS,
    PERMISSIONS.DELETE_USERS,
    PERMISSIONS.MANAGE_SOULS,
    PERMISSIONS.MANAGE_SHEPHERDS,
    PERMISSIONS.MANAGE_DEPARTMENTS,
    PERMISSIONS.MANAGE_FAMILIES,
    PERMISSIONS.MANAGE_SERVANTS,
    PERMISSIONS.VIEW_STATS,
    PERMISSIONS.EXPORT_DATA,
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.MANAGE_BACKUP,
    PERMISSIONS.MANAGE_INTERACTIONS,
    PERMISSIONS.MANAGE_AUDIO,
    PERMISSIONS.MANAGE_USER_MENUS,
    PERMISSIONS.MANAGE_SMS_TEMPLATES,
    PERMISSIONS.MANAGE_SMS,
    PERMISSIONS.MANAGE_PROFILE,
    PERMISSIONS.PROMOTE_SOUL_TO_SERVANT,
    PERMISSIONS.MANAGE_DEPARTMENT_SERVANTS,
    PERMISSIONS.VIEW_REPLAY_TEACHINGS,
    PERMISSIONS.MANAGE_BIRTHDAYS,
    PERMISSIONS.MANAGE_EVANGELIZED_SOULS
  ],
  [ROLES.SHEPHERD]: [
    PERMISSIONS.MANAGE_INTERACTIONS,
    PERMISSIONS.MANAGE_ATTENDANCES,
    PERMISSIONS.MANAGE_PROFILE,
    PERMISSIONS.MANAGE_SMS,
    PERMISSIONS.PROMOTE_SOUL_TO_SERVANT,
    PERMISSIONS.VIEW_REPLAY_TEACHINGS
  ],
  [ROLES.ADN]: [
    PERMISSIONS.MANAGE_SOULS,
    PERMISSIONS.MANAGE_INTERACTIONS,
    PERMISSIONS.MANAGE_PROFILE,
    PERMISSIONS.EXPORT_DATA,
    PERMISSIONS.MANAGE_SMS,
    PERMISSIONS.MANAGE_SMS_TEMPLATES,
    PERMISSIONS.MANAGE_AUDIO,
    PERMISSIONS.VIEW_REPLAY_TEACHINGS,
    PERMISSIONS.MANAGE_EVANGELIZED_SOULS
  ],
  [ROLES.DEPARTMENT_LEADER]: [
    PERMISSIONS.MANAGE_SERVANTS,
    PERMISSIONS.MANAGE_DEPARTMENT_SERVANTS,
    PERMISSIONS.MANAGE_INTERACTIONS,
    PERMISSIONS.MANAGE_ATTENDANCES,
    PERMISSIONS.MANAGE_PROFILE,
    PERMISSIONS.MANAGE_SMS,
    PERMISSIONS.PROMOTE_SOUL_TO_SERVANT,
    PERMISSIONS.VIEW_REPLAY_TEACHINGS
  ],
  [ROLES.FAMILY_LEADER]: [
    PERMISSIONS.MANAGE_SOULS,
    PERMISSIONS.MANAGE_INTERACTIONS,
    PERMISSIONS.MANAGE_PROFILE,
    PERMISSIONS.MANAGE_SMS,
    PERMISSIONS.VIEW_REPLAY_TEACHINGS
  ],
  [ROLES.EVANGELIST]: [
    PERMISSIONS.MANAGE_EVANGELIZED_SOULS,
    PERMISSIONS.MANAGE_INTERACTIONS,
    PERMISSIONS.MANAGE_SMS,
    PERMISSIONS.EXPORT_DATA,
    PERMISSIONS.MANAGE_PROFILE,
    PERMISSIONS.VIEW_REPLAY_TEACHINGS
  ]
} as const;